/*#__PURE__*/ export default {"key":"azMenu","type":"root","items":[{"key":"numberOfTopSports","def":3,"type":"number"}]};